import theme from '../../../../lib/theme';

const { layouts, corners, colors, media, scale } = theme;

export default () => ({
  panel: {
    ...layouts.panel,
  },

  row: {
    ...layouts.spacedColumn('m'),

    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    
    [media.s.up]: {
      ...layouts.spacedRow('m'),
    },
  },

  container: {
    ...layouts.container('l'),
    ...layouts.spacedColumn('s'),
    justifyContent: 'flex-start',
  },

  profileCard: {
    ...layouts.spacedColumn('s'),

    width: '100%',
    maxWidth: 400,
    backgroundColor: colors.sas.primary,
    borderRadius: corners.l,
    padding: scale.s,
  },

  profileCardRow: {
    // ...layouts.spacedColumn('s'),

    // [media.l.up]: {
      ...layouts.spacedRow('s'),
    // },

    '> img': {
      backgroundColor: '#ffffff',
    }
  },

  profileButtons: {
    ...layouts.spacedColumn('xs'),
    justifyContent: 'center',
  },

  profileCardText: {
    ...layouts.spacedColumn('xs'),
  },

  panelButton: {
    maxWidth: '300px',
  },

  alert: {
    fontSize: '1.1rem',
    width: '100%',
    margin: `0`,
  }
});
